import { computed, readonly, ref } from 'vue';

export type AsyncStatus = 'idle' | 'loading' | 'loaded' | 'failed';

export const useAsyncStatus = (initialStatus: AsyncStatus = 'idle') => {
  const status = ref<AsyncStatus>(initialStatus);

  const isIdle = computed(() => status.value === 'idle');
  const isLoading = computed(() => status.value === 'loading');
  const isLoaded = computed(() => status.value === 'loaded');
  const isFailed = computed(() => status.value === 'failed');

  const toIdle = () => {
    status.value = 'idle';
  };

  const toLoading = () => {
    status.value = 'loading';
  };

  const toLoaded = () => {
    status.value = 'loaded';
  };

  const toFailed = () => {
    status.value = 'failed';
  };

  return {
    status: readonly(status),
    isIdle,
    isLoading,
    isLoaded,
    isFailed,
    toIdle,
    toLoading,
    toLoaded,
    toFailed,
  };
};
